<template>
    <div class="mb-8 flex items-center justify-between px-7 pt-5">
        <span v-html="$snippets['headless.plp.filterAndSort']" class="styled-as-h3 text-[14px]"></span>
        <div class="flex justify-end">
            <button @click="mobileFiltersMenuStore.closeMenu()" class="flex items-center tracking-[0.8px]">
                {{ $snippets['headless.plp.close'] }}
                <ArrowRightIcon class="ml-3 size-5 stroke-2 duration-300 group-hover:translate-x-1" />
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ArrowRightIcon } from '@heroicons/vue/24/outline';
    const mobileFiltersMenuStore = useMobileFiltersMenuStore();
</script>
